// ========================================================================
// URL HELPERS - ORGANIZADOS POR CATEGORÍAS
// ========================================================================

// ========================================================================
// 🌐 CONFIGURACIÓN BASE
// ========================================================================

// Server URLs
//const SERVER_URL = "http://localhost:3001"; // Local development
const SERVER_URL = "https://apipro.intern.saludti.es"; // Production

// Base API URLs
export const API_BASE_URL = SERVER_URL + '/api';
export const API_BASE_GENERIC = API_BASE_URL + "/model/";

// Dont know where is this used
//export const API_LOCAL_URL = "http://localhost:5001";


// ========================================================================
// 🔐 AUTENTICACIÓN - CON RUTAS DEFINIDAS ✅
// ========================================================================

export const API_LOGIN = "/auth/login";
export const API_REGISTER = "/auth/register";

// ========================================================================
// 👩‍⚕️ GESTIÓN DE DOCTORES - CON RUTAS DEFINIDAS ✅
// ========================================================================

export const API_DOCTOR_LIST = `${API_BASE_URL}/users?role=doctor`;
export const API_DOCTOR_CREATE = `${API_BASE_URL}/users/create`;
export const API_DOCTOR_UPDATE = (id) => `${API_BASE_URL}/model/user/${id}`;
export const API_DOCTOR_DELETE = (id) => `${API_BASE_URL}/model/user/${id}`;

// ========================================================================
// 🧑‍🤝‍🧑 GESTIÓN DE PACIENTES - CON RUTAS DEFINIDAS ✅
// ========================================================================

export const API_PATIENT_LIST = "/users?role=patient";
export const API_PATIENT_CREATE = "/users/create";
export const API_PATIENT_UPDATE = "/users/update";
export const API_GENERIC_PATIENT_UPDATE = "/model/user/:id";
export const API_GENERIC_PATIENT_DELETE = "/model/user/:id";
export const API_PATIENT_DELETE = "/user/:id";

// ========================================================================
// 💊 GESTIÓN DE PRESCRIPCIONES - CON RUTAS ACTUALIZADAS ✅
// ========================================================================

export const API_BASE_PRESCRIPTION_URL = `${API_BASE_URL}`;

// Rutas principales de prescripciones
export const API_PRESCRIPTION_LIST = "/prescriptions";
export const API_PRESCRIPTION_DETAILS = "/prescriptions";
export const API_PRESCRIPTION_MOCK = '/prescriptions/mock';
export const API_PRESCRIPTION_CREATE = '/prescriptions';
export const API_PRESCRIPTION_UPDATE = '/prescriptions'; // Cambiado: ahora usa PUT /:id
export const API_PRESCRIPTION_DELETE = '/prescriptions'; // Cambiado: ahora usa DELETE /:id
export const API_PRESCRIPTION_TOGGLE_STATUS = '/prescriptions'; // Para PATCH /:id/toggle-status

// Datos relacionados con prescripciones
export const API_DOCTORS = "/doctors";
export const API_PATIENTS = "/patients";
export const API_MEDICINES = "/medicines";
export const API_SUPPLIER_LIST = "/approvals";

// ========================================================================
// 🏥 TRATAMIENTOS - CON RUTAS DEFINIDAS ✅
// ========================================================================

export const API_TREATMENTM_LIST = "/treatmentManagement";
export const API_TREATMENTM_CREATE = "/treatmentManagement";
export const API_TREATMENTM_UPDATE = "/treatmentManagement/:id";
export const API_TREATMENTM_DELETE = "/treatmentManagement/:id";
export const API_TREATMENTM_USER = "/treatmentManagement/:id";
export const API_TREATMENTM_MOCK = "/treatmentManagement/mock";

// ========================================================================
// 🏥 CENTROS DE SALUD - CON RUTAS DEFINIDAS ✅
// ========================================================================

export const API_BASE_HEALTH_CENTER_URL = `${API_BASE_URL}/healthCenters`;
export const API_HEALTH_CENTERS = '/clinics';
export const API_HEALTH_CENTER_BY_ID = '/clinics';

// ========================================================================
// 📦 INVENTARIO - CON RUTAS DEFINIDAS ✅
// ========================================================================

export const API_INVENTORY = "/model/product";
export const API_BASE_INVENTORY_URL = `${API_BASE_URL}/model`;
export const API_INVENTORY_LIST = '/inventory';
export const API_INVENTORY_CREATE = '/inventory/create';
export const API_INVENTORY_UPDATE = '/inventory/update';
export const API_INVENTORY_DELETE = '/inventory/delete';

// ========================================================================
// 💉 MEDICAMENTOS - CON RUTAS DEFINIDAS ✅
// ========================================================================

export const API_MEDICINE_BASE = API_BASE_URL;
export const API_MEDICINE_LIST = API_MEDICINE_BASE;
export const API_MEDICINE_CREATE = API_MEDICINE_BASE;
export const API_MEDICINE_UPDATE = API_MEDICINE_BASE;
export const API_MEDICINE_DELETE = API_MEDICINE_BASE;
export const API_MEDICINE_GET_ONE = API_MEDICINE_BASE;

// ========================================================================
// 🔧 HERRAMIENTAS - VISUALIZADOR CON RUTAS DEFINIDAS ✅
// ========================================================================

export const API_BASE_VISUALIZER = process.env.REACT_APP_API_VISUALIZER || 'http://localhost:3001/api';
export const API_INTERACTIONS = '/interactions';

// ========================================================================
// 🏢 PROCESOS DE EMPRESA - CON RUTAS DEFINIDAS ✅
// ========================================================================

export const API_BASE_COMPANYPROCESS_URL = `${API_BASE_URL}`;
export const API_COMPANYPROCESS_LIST = "/companyProcess";
export const API_COMPANYPROCESS_CREATE = "/companyProcess";
export const API_COMPANYPROCESS_UPDATE = "/companyProcess";
export const API_COMPANYPROCESS_DELETE = "/companyProcess";

// ========================================================================
// 💉 GESTIÓN DE VACUNACIÓN - CON RUTAS DEFINIDAS ✅
// ========================================================================

export const API_BASE_VACCINATION_URL = `${API_BASE_URL}`;
export const API_VACCINATION_LIST = "/vaccinations";
export const API_VACCINATION_DETAILS = "/vaccinations";
export const API_VACCINATION_CREATE = "/vaccinations";
export const API_VACCINATION_UPDATE = "/vaccinations";
export const API_VACCINATION_DELETE = "/vaccinations";
export const API_VACCINATION_BULK_ACTION = "/vaccinations/bulk-action";
export const API_VACCINATION_SEND_REMINDER = "/vaccinations/send-reminder";

// ========================================================================
// 📋 APPOINTMENT URL HELPERS - VERSIÓN COMPLETA CON TODOS LOS ENDPOINTS
// ========================================================================

export const API_BASE_APPOINTMENT_URL = `${API_BASE_URL}/appointments`;

// ========================================================================
// 📋 ENDPOINTS DEFINITION - TODOS LOS PATHS DISPONIBLES
// ========================================================================

// Endpoints base
export const API_APPOINTMENTS_BASE = "";
export const API_APPOINTMENTS_BY_APPOINTMENT_ID = "/appointment-id";

// ✅ Endpoints de verificación/utilidades
export const API_APPOINTMENTS_CHECK_DESPACHO = "/check-despacho-availability";

// ✅ Endpoints por productos
export const API_APPOINTMENTS_BY_PRODUCT = "/by-product";
export const API_APPOINTMENTS_BY_DESPACHO = "/by-despacho";

// Endpoints por usuario
export const API_APPOINTMENTS_DOCTOR = "/doctor";
export const API_APPOINTMENTS_PATIENT = "/patient";

// Endpoints de gestión de estados
export const API_APPOINTMENTS_ACCEPT = "/accept";
export const API_APPOINTMENTS_STATUS = "/status";
export const API_APPOINTMENTS_CHECKIN = "/checkin";
export const API_APPOINTMENTS_START_CONSULTATION = "/start-consultation";
export const API_APPOINTMENTS_COMPLETE = "/complete";

// Endpoints de acciones específicas
export const API_APPOINTMENTS_WALK_IN = "/walk-in";
export const API_APPOINTMENTS_RESCHEDULE = "/reschedule";
export const API_APPOINTMENTS_CANCEL = "/cancel";
export const API_APPOINTMENTS_CONFIRM = "/confirm";
export const API_APPOINTMENTS_NO_SHOW = "/no-show";

// ✅ Endpoints de pagos
export const API_APPOINTMENTS_PAYMENT = "/payment";
export const API_APPOINTMENTS_REFUND = "/refund";

// Endpoints específicos para vistas de doctor
export const API_APPOINTMENTS_TODAY = "/today";
export const API_APPOINTMENTS_PENDING = "/pending";
export const API_APPOINTMENTS_WAITING_QUEUE = "/waiting-queue";
export const API_APPOINTMENTS_WALK_IN_LIST = "/walk-in";
export const API_APPOINTMENTS_CANCELLED = "/cancelled";
export const API_APPOINTMENTS_PAYMENT_STATS = "/payment-stats";

// ========================================================================
// 🔧 UTILITY FUNCTIONS
// ========================================================================

/**
 * Build query string from params object
 * @param {Object} params - Query parameters
 * @returns {string} Query string (e.g., "?key1=value1&key2=value2")
 */
export const buildQueryString = (params = {}) => {
  const filteredParams = Object.entries(params)
    .filter(([_, value]) => value !== undefined && value !== null && value !== '')
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');
  
  return filteredParams ? `?${filteredParams}` : '';
};

/**
 * Build complete URL with base and path
 * @param {string} base - Base URL
 * @param {string} path - Path to append
 * @param {Object} params - Query parameters
 * @returns {string} Complete URL
 */
export const buildUrl = (base, path = '', params = {}) => {
  const url = `${base}${path}`;
  const queryString = buildQueryString(params);
  return `${url}${queryString}`;
};

// ========================================================================
// 📝 GESTIÓN DE NOTAS - CON RUTAS DEFINIDAS ✅
// ========================================================================

export const API_BASE_NOTES_URL = `${API_BASE_URL}`;
export const API_NOTES_LIST = "/notes";
export const API_NOTES_DETAILS = "/notes";
export const API_NOTES_CREATE = "/notes";
export const API_NOTES_UPDATE = "/notes";
export const API_NOTES_DELETE = "/notes";
export const API_NOTES_BY_PATIENT = "/notes/patient";
export const API_NOTES_SEARCH = "/notes/patient";
export const API_NOTES_ARCHIVE = "/notes";

// ========================================================================
// 📝 GESTIÓN DE TRATAMIENTOS DETALLADOS - CONSTANTES URLs ✅
// ========================================================================
export const API_BASE_DETAIL_TREATMENTS_URL = `${API_BASE_URL}/detail-treatments`;

// URLs base para diferentes funcionalidades
export const API_DETAIL_TREATMENTS_ALL = "/all";
export const API_DETAIL_TREATMENTS_STATS = "/stats";
export const API_DETAIL_TREATMENTS_LIST = "";
export const API_DETAIL_TREATMENTS_DETAILS = "";
export const API_DETAIL_TREATMENTS_CREATE = "";
export const API_DETAIL_TREATMENTS_UPDATE = "";
export const API_DETAIL_TREATMENTS_DELETE = "";

// URLs para funcionalidades específicas por entidad
export const API_DETAIL_TREATMENTS_BY_PATIENT = "/patient";
export const API_DETAIL_TREATMENTS_SUMMARY = "/patient";
export const API_DETAIL_TREATMENTS_BY_DOCTOR = "/doctor";

// URLs para operaciones especiales
export const API_DETAIL_TREATMENTS_CREATE_FROM_EXISTING = "/create-from-existing";
export const API_DETAIL_TREATMENTS_UPDATE_CONSENT = "";
export const API_DETAIL_TREATMENTS_UPDATE_PROGRESS = "";
export const API_DETAIL_TREATMENTS_UPDATE_DOCTOR = "";

// Sufijos para operaciones específicas
export const CONSENT_SUFFIX = "/consent";
export const PROGRESS_SUFFIX = "/progress";
export const DOCTOR_INFO_SUFFIX = "/doctor-info";
export const SUMMARY_SUFFIX = "/summary";

// ========================================================================
// 🧪 GESTIÓN DE PLANTILLAS DE PRUEBAS DE LABORATORIO - CON RUTAS DEFINIDAS ✅
// ========================================================================

export const API_BASE_LAB_TEMPLATES_URL = `${API_BASE_URL}`;

// Rutas de consulta
export const API_LAB_TEMPLATES_LIST = "/lab-test-templates";
export const API_LAB_TEMPLATES_DETAILS = "/lab-test-templates"; // GET /:id
export const API_LAB_TEMPLATES_BY_CODE = "/lab-test-templates/code"; // GET /code/:code
export const API_LAB_TEMPLATES_CATEGORIES = "/lab-test-templates/categories"; // GET /categories
export const API_LAB_TEMPLATES_SAMPLE_TYPES = "/lab-test-templates/sample-types"; // GET /sample-types
export const API_LAB_TEMPLATES_STATS = "/lab-test-templates/stats"; // GET /stats

// Rutas de creación
export const API_LAB_TEMPLATES_CREATE = "/lab-test-templates"; // POST /
export const API_LAB_TEMPLATES_BULK_CREATE = "/lab-test-templates/bulk"; // POST /bulk

// Rutas de actualización
export const API_LAB_TEMPLATES_UPDATE = "/lab-test-templates"; // PUT /:id

// Rutas de eliminación y gestión de estado
export const API_LAB_TEMPLATES_DELETE = "/lab-test-templates"; // DELETE /:id (soft delete)
export const API_LAB_TEMPLATES_HARD_DELETE = "/lab-test-templates"; // DELETE /:id/hard (permanente)
export const API_LAB_TEMPLATES_REACTIVATE = "/lab-test-templates"; // PATCH /:id/reactivate


// ========================================================================
// 🧪 GESTIÓN DE ÓRDENES DE LABORATORIO - CON RUTAS DEFINIDAS ✅
// ========================================================================

export const API_BASE_LAB_ORDERS_URL = `${API_BASE_URL}`;
export const API_LAB_ORDERS_LIST = "/laboratory/orders";
export const API_LAB_ORDERS_CREATE = "/laboratory/orders";
export const API_LAB_ORDERS_DETAILS = "/laboratory/orders";
export const API_LAB_ORDERS_BY_PATIENT = "/laboratory/patients";
export const API_LAB_ORDERS_UPDATE_RESULTS = "/laboratory/orders";

// ========================================================================
// 🏥 GESTIÓN DE IMÁGENES DIAGNÓSTICAS - CON RUTAS DEFINIDAS ✅
// ========================================================================

export const API_BASE_DIAGNOSTIC_IMAGING_URL = `${API_BASE_URL}`;

// Rutas básicas CRUD
export const API_DIAGNOSTIC_IMAGING_LIST = "/diagnostic-imaging";
export const API_DIAGNOSTIC_IMAGING_DETAILS = "/diagnostic-imaging"; // GET /:id
export const API_DIAGNOSTIC_IMAGING_CREATE = "/diagnostic-imaging";  // POST /
export const API_DIAGNOSTIC_IMAGING_UPDATE = "/diagnostic-imaging";  // PUT /:id
export const API_DIAGNOSTIC_IMAGING_DELETE = "/diagnostic-imaging";  // DELETE /:id

// Rutas específicas "http://localhost:5001/api"
export const API_DIAGNOSTIC_IMAGING_STATS = "/diagnostic-imaging/stats";
export const API_DIAGNOSTIC_IMAGING_STATUS = "/diagnostic-imaging"; // PATCH /:id/status
export const API_DIAGNOSTIC_IMAGING_BY_PATIENT = "/diagnostic-imaging/patient"; // GET /patient/:patientId
export const API_DIAGNOSTIC_IMAGING_REMOVE_FILE = "/diagnostic-imaging"; // DELETE /:id/files/:fileId

// ========================================================================
// 🧬 GESTIÓN DE MEDICINA MOLECULAR - CON RUTAS DEFINIDAS ✅
// ========================================================================

export const API_BASE_MOLECULAR_MEDICINE_URL = `${API_BASE_URL}`;

// Rutas básicas CRUD
export const API_MOLECULAR_MEDICINE_LIST = "/molecular-medicine";
export const API_MOLECULAR_MEDICINE_DETAILS = "/molecular-medicine"; // GET /:id
export const API_MOLECULAR_MEDICINE_CREATE = "/molecular-medicine";  // POST /
export const API_MOLECULAR_MEDICINE_UPDATE = "/molecular-medicine";  // PUT /:id
export const API_MOLECULAR_MEDICINE_DELETE = "/molecular-medicine";  // DELETE /:id

// Rutas de estadísticas y casos urgentes
export const API_MOLECULAR_MEDICINE_STATS = "/molecular-medicine/stats";
export const API_MOLECULAR_MEDICINE_URGENT = "/molecular-medicine/urgent";

// Rutas de búsqueda
export const API_MOLECULAR_MEDICINE_SEARCH_GENE = "/molecular-medicine/search/gene"; // GET /search/gene/:gene
export const API_MOLECULAR_MEDICINE_BY_PATIENT = "/molecular-medicine/patient"; // GET /patient/:patientId

// Rutas de estado
export const API_MOLECULAR_MEDICINE_STATUS = "/molecular-medicine"; // PATCH /:id/status

// Rutas de archivos
export const API_MOLECULAR_MEDICINE_REMOVE_FILE = "/molecular-medicine"; // DELETE /:id/files/:fileId
export const API_MOLECULAR_MEDICINE_ADD_FILES = "/molecular-medicine"; // POST /:id/files

// Rutas de hallazgos genéticos
export const API_MOLECULAR_MEDICINE_ADD_FINDING = "/molecular-medicine"; // POST /:id/findings
export const API_MOLECULAR_MEDICINE_UPDATE_FINDING = "/molecular-medicine"; // PUT /:id/findings/:findingId
export const API_MOLECULAR_MEDICINE_PATHOGENIC_FINDINGS = "/molecular-medicine"; // GET /:id/findings/pathogenic
export const API_MOLECULAR_MEDICINE_DELETE_FINDING = "/molecular-medicine"; // DELETE /:id/findings/:findingId

// Rutas de filtros avanzados
export const API_MOLECULAR_MEDICINE_FILTER_TYPE = "/molecular-medicine/filter/type"; // GET /filter/type/:type
export const API_MOLECULAR_MEDICINE_FILTER_STATUS = "/molecular-medicine/filter/status"; // GET /filter/status/:status
export const API_MOLECULAR_MEDICINE_FILTER_CLINICAL_AREA = "/molecular-medicine/filter/clinical-area"; // GET /filter/clinical-area/:area
export const API_MOLECULAR_MEDICINE_FILTER_PRIORITY = "/molecular-medicine/filter/priority"; // GET /filter/priority/:priority

// Rutas de reportes
export const API_MOLECULAR_MEDICINE_REPORT_DATE_RANGE = "/molecular-medicine/reports/date-range";
export const API_MOLECULAR_MEDICINE_REPORT_PROCESSING_TIMES = "/molecular-medicine/reports/processing-times";

// Rutas de utilidades
export const API_MOLECULAR_MEDICINE_FORM_OPTIONS = "/molecular-medicine/utils/form-options";
export const API_MOLECULAR_MEDICINE_VALIDATE_GENE = "/molecular-medicine/utils/validate-gene"; // GET /utils/validate-gene/:gene

// ========================================================================
// 🏥 GESTIÓN DE TAREAS DE ENFERMERÍA - CON RUTAS DEFINIDAS ✅
// ========================================================================

export const API_BASE_NURSING_TASKS_URL = `${API_BASE_URL}`;
export const API_NURSING_TASKS_LIST = "/nursing-tasks";
export const API_NURSING_TASKS_DETAILS = "/nursing-tasks";
export const API_NURSING_TASKS_CREATE = "/nursing-tasks";
export const API_NURSING_TASKS_UPDATE = "/nursing-tasks";
export const API_NURSING_TASKS_DELETE = "/nursing-tasks";
export const API_NURSING_TASKS_DAILY = "/nursing-tasks/daily";
export const API_NURSING_TASKS_OVERDUE = "/nursing-tasks/overdue";
export const API_NURSING_TASKS_BY_PATIENT = "/nursing-tasks/patient";
export const API_NURSING_TASKS_COMPLETE = "/nursing-tasks";
export const API_NURSING_TASKS_CANCEL = "/nursing-tasks";
export const API_NURSING_TASKS_START = "/nursing-tasks";


// ========================================================================
// 📄 FACTURAS - SIN RUTAS DEFINIDAS ❌
// ========================================================================

export const API_BASE_INVOICE_URL = `${API_BASE_URL}/model/invoice`;
export const API_INVOICE_LIST = API_BASE_INVOICE_URL;
export const API_INVOICE_CREATE = API_BASE_INVOICE_URL;
export const API_INVOICE_UPDATE = (id) => `${API_BASE_INVOICE_URL}/${id}`;
export const API_INVOICE_DELETE = (id) => `${API_BASE_INVOICE_URL}/${id}`;
export const API_INVOICE_GET_ONE = (id) => `${API_BASE_INVOICE_URL}/${id}`;

// ========================================================================
// 🏥 GESTIÓN DE REGISTROS MÉDICOS - CON RUTAS DEFINIDAS ✅ `${API_BASE_URL}`;
// ========================================================================

export const API_BASE_MEDICAL_RECORDS_URL = `${API_BASE_URL}`;
export const API_MEDICAL_RECORDS_LIST = "/medical-records";
export const API_MEDICAL_RECORDS_DETAILS = "/medical-records";
export const API_MEDICAL_RECORDS_CREATE = "/medical-records";
export const API_MEDICAL_RECORDS_UPDATE = "/medical-records";
export const API_MEDICAL_RECORDS_DELETE = "/medical-records";
export const API_MEDICAL_RECORDS_UPDATE_STATUS = "/medical-records";
export const API_MEDICAL_RECORDS_PATIENT_STATS = "/medical-records/patient";

// ========================================================================
// 🛒 GESTIÓN DE COMPRAS - SIN RUTAS DEFINIDAS ❌
// ========================================================================

export const API_PURCHASE_LIST = "/model/purchaseList";
export const API_PURCHASE_LIST_ID = "/model/purchaseList/";
export const API_PURCHASE_LIST_CREATE = "/model/purchaseList/create";
export const API_PURCHASE_LIST_UPDATE = "/model/purchaseList/";
export const API_PURCHASE_LIST_DELETE = "/model/purchaseList/delete/";

// Necesidades de compra
export const API_PURCHASE_NEEDS = "/model/purchaseNeed";

// Solicitudes de compra
export const API_BASE_URL_PURCHASE_REQUEST = `${API_BASE_URL}`;
export const API_PURCHASE_REQUEST_LIST = '/purchases';
export const API_PURCHASE_REQUEST_ID = '/purchases/:id';
export const API_PURCHASE_REQUEST_CREATE = '/purchases/create';
export const API_PURCHASE_REQUEST_UPDATE = '/purchases/update';

// ========================================================================
// 🎯 CONTROL DE CALIDAD - SIN RUTAS DEFINIDAS ❌
// ========================================================================

export const API_BASE_QUALITY_CONTROL_URL = `${API_BASE_URL}/model/qualityControl`;
export const API_QUALITY_CONTROL_LIST = '/';
export const API_QUALITY_CONTROL_DETAIL = '/:id';
export const API_QUALITY_CONTROL_CREATE = '/create';
export const API_QUALITY_CONTROL_UPDATE = '/update/:id';
export const API_QUALITY_CONTROL_DELETE = '/delete/:id';
export const API_QUALITY_CONTROL_TEST = '/:qualityControlId/items/:itemId/test-results';
export const API_QUALITY_CONTROL_DEFECT = '/:qualityControlId/items/:itemId/defects';
export const API_QUALITY_CONTROL_BULK_UPDATE = '/items/bulk-update-status';
export const API_QUALITY_CONTROL_BULK_PRIORITY = '/items/bulk-update-priority';

// ========================================================================
// 💰 COTIZACIONES - SIN RUTAS DEFINIDAS ❌
// ========================================================================

export const API_BASE_QUOTATIONS_URL = process.env.REACT_APP_API_BASE_URL || `${API_BASE_URL}/model`;
export const API_QUOTATIONS_LIST = "/quotation";
export const API_QUOTATIONS_CREATE = "/quotation";
export const API_QUOTATIONS_UPDATE = "/quotation";
export const API_QUOTATIONS_DELETE = "/quotation";

// ========================================================================
// 🏭 GESTIÓN DE PROVEEDORES - SIN RUTAS DEFINIDAS ❌
// ========================================================================

export const API_BASE_URL_MANAGE_SUPPLIER = `${API_BASE_URL}/model/supplierApproval`;
export const API_SUPPLIER_APPROVAL_CREATE = "/approvals/create";
export const API_SUPPLIER_APPROVAL_DELETE = "/approvals/:id";

// ========================================================================
// 📍 GESTIÓN DE UBICACIONES - SIN RUTAS DEFINIDAS ❌
// ========================================================================

export const API_BASE_LOCATION_URL = `${API_BASE_URL}/model`;
export const API_LOCATION_LIST = '/location';
export const API_LOCATION_CREATE = '/location/create';
export const API_LOCATION_UPDATE = '/location/update';
export const API_LOCATION_DELETE = '/location/delete';

// ========================================================================
// 🚚 GESTIÓN DE MOVIMIENTOS - SIN RUTAS DEFINIDAS ❌
// ========================================================================

export const API_BASE_MOVEMENT_URL = `${API_BASE_URL}/model`;
export const API_MOVEMENT_LIST = '/movements';
export const API_MOVEMENT_CREATE = '/movements/create';
export const API_MOVEMENT_UPDATE = '/movements/update';
export const API_MOVEMENT_DELETE = '/movements/delete';

// ========================================================================
// 📦 GESTIÓN DE ENTREGAS - SIN RUTAS DEFINIDAS ❌
// ========================================================================

export const API_BASE_ENTREGAS_URL = `${API_BASE_URL}/model`;
export const API_ENTREGAS_LIST = '/entregas';
export const API_ENTREGAS_CREATE = '/entregas/create';
export const API_ENTREGAS_UPDATE = '/entregas/update';
export const API_ENTREGAS_DELETE = '/entregas/delete';

// ========================================================================
// 📋 GESTIÓN DE PLANIFICACIÓN - SIN RUTAS DEFINIDAS ❌
// ========================================================================

export const API_BASE_PLANIFICACION_URL = `${API_BASE_URL}/model`;
export const API_PLANIFICACION_LIST = '/planificacion';
export const API_PLANIFICACION_CREATE = '/planificacion/create';
export const API_PLANIFICACION_UPDATE = '/planificacion/update';
export const API_PLANIFICACION_DELETE = '/planificacion/delete';

// ========================================================================
// 🏷️ GESTIÓN DE LOTES - SIN RUTAS DEFINIDAS ❌
// ========================================================================

export const API_BASE_LOTES_URL = `${API_BASE_URL}/model`;
export const API_LOTES_LIST = '/lotes';
export const API_LOTES_CREATE = '/lotes';
export const API_LOTES_UPDATE = '/lotes';
export const API_LOTES_DELETE = '/lotes';

// ========================================================================
// 📊 EVALUACIÓN DE OFERTAS - SIN RUTAS DEFINIDAS ❌
// ========================================================================

export const API_OFFER_EVALUATION_BASE_PATH = "/offerevaluation";
export const API_OFFER_EVALUATIONS_LIST = API_OFFER_EVALUATION_BASE_PATH;
export const API_OFFER_EVALUATION_CREATE = `${API_OFFER_EVALUATION_BASE_PATH}/create`;

// ========================================================================
// 👥 PROCESOS DE CLIENTES - SIN RUTAS DEFINIDAS ❌
// ========================================================================

export const API_BASE_CLIENTPROCESS_URL = `${API_BASE_URL}`;
export const API_CLIENTPROCESS_LIST = "/clientProcess";
export const API_CLIENTPROCESS_CREATE = "/clientProcess";
export const API_CLIENTPROCESS_UPDATE = "/clientProcess";
export const API_CLIENTPROCESS_DELETE = "/clientProcess";

// ========================================================================
// 📝 FORMULARIOS DE CLIENTES - SIN RUTAS DEFINIDAS ❌
// ========================================================================

export const API_BASE_CLIENTFORM_URL = `${API_BASE_URL}`;
export const API_CLIENTFORM_LIST = "/clientForm";
export const API_CLIENTFORM_CREATE = "/clientForm";
export const API_CLIENTFORM_UPDATE = "/clientForm";
export const API_CLIENTFORM_DELETE = "/clientForm";

// ========================================================================
// 🔗 INTEGRACIONES EXTERNAS CIMA - RUTAS CORREGIDAS
// ========================================================================

// N8N Integration
export const API_N8N_CLIENT = `${API_BASE_URL}/webhook-test/webhook/client-form-completed`; 

// CIMA Integration - Rutas corregidas según tu backend
export const API_CIMA_SEARCH = '/cima/medicamentos';           // GET /api/cima/medicamentos (con filtros)
export const API_CIMA_DETALLE = '/cima/medicamento';           // GET /api/cima/medicamento (por nregistro)
export const API_CIMA_ALL = '/cima/medicamentos';              // Mismo endpoint, sin filtros para obtener todos
export const API_CIMA_PRESENTACIONES = '/cima/presentaciones'; // GET /api/cima/presentaciones
export const API_CIMA_PRESENTACION = '/cima/presentacion';     // GET /api/cima/presentacion/:codNacional
export const API_CIMA_SUMINISTRO = '/cima/psuministro';        // GET /api/cima/psuministro
export const API_CIMA_VMPP = '/cima/vmpp';                     // GET /api/cima/vmpp
export const API_CIMA_NOTAS = '/cima/notas';                   // GET /api/cima/notas
export const API_CIMA_MATERIALES = '/cima/materiales';         // GET /api/cima/materiales

// ========================================================================
// 🔗 LOINC CODES - RUTAS
// ========================================================================

export const API_BASE_LOINC_URL = `${API_BASE_URL}`;

// LOINC Integration - Rutas según el backend
export const API_LOINC_ALL = '/loinc';                    // GET /api/loinc (todos los códigos con paginación opcional)
export const API_LOINC_SEARCH = '/loinc/search';          // GET /api/loinc/search (búsqueda con filtros)
export const API_LOINC_STATS = '/loinc/stats';            // GET /api/loinc/stats (estadísticas)
export const API_LOINC_CATEGORIES = '/loinc/categories';  // GET /api/loinc/categories (categorías disponibles)
export const API_LOINC_VALIDATE = '/loinc/validate';      // POST /api/loinc/validate (validar código)
export const API_LOINC_BY_NUMBER = '/loinc/number';       // GET /api/loinc/number/:loincNum (por número LOINC)
export const API_LOINC_BY_ID = '/loinc';                  // GET /api/loinc/:id (por ID de MongoDB)

// ========================================================================
// 📁 SUBIDA DE ARCHIVOS - SIN RUTAS DEFINIDAS ❌
// ========================================================================

export const API_FILE_UPLOAD_SINGLE = "https://apipro.intern.saludti.es/uploads/single";
export const API_FILE_UPLOAD_MULTIPLE = "https://apipro.intern.saludti.es/uploads/multiple";

// ========================================================================
// 🔧 HELPERS GENÉRICOS - SIN RUTAS DEFINIDAS ❌
// ========================================================================

export const getModelListUrl = (modelName) => `${API_BASE_GENERIC}/${modelName}`;
export const getModelByIdUrl = (modelName, id) => `${API_BASE_GENERIC}/${modelName}/${id}`;
export const createModelUrl = (modelName) => `${API_BASE_GENERIC}/${modelName}`;
export const updateModelUrl = (modelName, id) => `${API_BASE_GENERIC}/${modelName}/${id}`;
export const deleteModelUrl = (modelName, id) => `${API_BASE_GENERIC}/${modelName}/${id}`;

// ========================================================================
// 🚨 HERRAMIENTAS SIN APIs ESPECÍFICAS - TIENEN RUTAS PERO NO URLs ⚠️
// ========================================================================

// Las siguientes herramientas tienen rutas definidas pero no APIs específicas:
// - Diagnostic Assistant (/diagnostic-assistant)
// - Smart Translator (/smarttranslator)
// - Symptom Assistant (/symptom-assistant)
// - Digimevo (/digimevo)
// - CogniEva (/evaluacion-cognitiva)
// - Health Assistant (/health-assistant)

// ========================================================================
// PATIENT MANAGEMENT VIEW 
// ========================================================================

// ========================================================================
// 🤧 GESTIÓN DE ALERGIAS - CON RUTAS DEFINIDAS ✅
// ========================================================================

export const API_BASE_ALLERGY_URL = `${API_BASE_URL}`;
export const API_ALLERGY_LIST = "/allergies";
export const API_ALLERGY_DETAILS = "/allergies";
export const API_ALLERGY_CREATE = "/allergies";
export const API_ALLERGY_UPDATE = "/allergies";
export const API_ALLERGY_DELETE = "/allergies";
export const API_ALLERGY_HARD_DELETE = "/allergies"; // Para hard delete agregar /hard al final
export const API_ALLERGY_BY_PATIENT = "/allergies/patient";
export const API_ALLERGY_BULK_ACTION = "/allergies/bulk-action";
export const API_ALLERGY_EXPORT = "/allergies/export";
export const API_ALLERGY_STATISTICS = "/allergies/statistics";

// ========================================================================
// 🏥 GESTIÓN DE REGISTROS DE SALUD - CON RUTAS DEFINIDAS ACTUALIZADAS ✅
// ========================================================================

export const API_BASE_HEALTHLOG_URL = `${API_BASE_URL}`;

// Rutas principales CRUD
export const API_HEALTHLOG_LIST = "/health-logs";
export const API_HEALTHLOG_DETAILS = "/health-logs";
export const API_HEALTHLOG_CREATE = "/health-logs";
export const API_HEALTHLOG_UPDATE = "/health-logs";
export const API_HEALTHLOG_DELETE = "/health-logs";
export const API_HEALTHLOG_BY_USER = "/health-logs/user";

// Rutas adicionales (futuras implementaciones)
export const API_HEALTHLOG_BULK_ACTION = "/health-logs/bulk-action";
export const API_HEALTHLOG_EXPORT = "/health-logs/export";
export const API_HEALTHLOG_STATISTICS = "/health-logs/statistics";

// Rutas específicas para subsecciones - ACTUALIZADAS según el backend
export const API_HEALTHLOG_VITALS = "/health-logs";
export const API_HEALTHLOG_BODY_MEASUREMENTS = "/health-logs";
export const API_HEALTHLOG_SUGAR_PROFILE = "/health-logs";
export const API_HEALTHLOG_LIVER_PROFILE = "/health-logs";
export const API_HEALTHLOG_KIDNEY_PROFILE = "/health-logs";
export const API_HEALTHLOG_LIPID_PROFILE = "/health-logs";
export const API_HEALTHLOG_CYCLE_TRACKING = "/health-logs";
export const API_HEALTHLOG_PREGNANCY_TRACKING = "/health-logs";

// Rutas específicas para obtener datos (GET)
export const API_HEALTHLOG_GET_VITALS = "/health-logs";
export const API_HEALTHLOG_GET_LATEST_VITALS = "/health-logs";


// ========================================================================
// 💉 GESTIÓN DE INMUNIZACIONES - CON RUTAS DEFINIDAS ✅
// ========================================================================

export const API_BASE_IMMUNIZATION_URL = `${API_BASE_URL}`;
export const API_IMMUNIZATION_LIST = "/immunizations";
export const API_IMMUNIZATION_DETAILS = "/immunizations";
export const API_IMMUNIZATION_CREATE = "/immunizations";
export const API_IMMUNIZATION_UPDATE = "/immunizations";
export const API_IMMUNIZATION_DELETE = "/immunizations";
export const API_IMMUNIZATION_BY_PATIENT = "/immunizations/patient";
export const API_IMMUNIZATION_STATS = "/immunizations/stats";
export const API_IMMUNIZATION_UPCOMING = "/immunizations/upcoming";

// ========================================================================
// 💊 GESTIÓN DE PRESCRIPCIONES - CON RUTAS DEFINIDAS ✅
// ========================================================================

// Base para prescripciones
export const API_BASE_PRESCRIPTION_PATIENT_URL = `${API_BASE_URL}`;

// ========================================================================
// 🔧 RUTAS PRINCIPALES CRUD (Coinciden con tu Express Router)
// ========================================================================

// Rutas principales CRUD - Basadas en tu router de Express
export const API_PRESCRIPTION_PATIENT_LIST = "/prescriptions";           // GET /api/prescriptions
export const API_PRESCRIPTION_PATIENT_DETAILS = "/prescriptions";        // GET /api/prescriptions/:id
export const API_PRESCRIPTION_PATIENT_CREATE = "/prescriptions";         // POST /api/prescriptions
export const API_PRESCRIPTION_PATIENT_UPDATE = "/prescriptions";         // PUT /api/prescriptions/:id
export const API_PRESCRIPTION_PATIENT_DELETE = "/prescriptions";         // DELETE /api/prescriptions/:id

// ========================================================================
// 💊 RECETAS ELECTRÓNICAS - URL HELPERS ACTUALIZADOS
// ========================================================================

export const API_BASE_ELECTRONIC_PRESCRIPTION_URL = `${API_BASE_URL}/electronicPrescriptions`;

// **RUTAS PRINCIPALES**
export const API_ELECTRONIC_PRESCRIPTION_GET_ALL = ""; // Para mostrar todas
export const API_ELECTRONIC_PRESCRIPTION_CREATE = "";
export const API_ELECTRONIC_PRESCRIPTION_GET_BY_ID = "/:id";
export const API_ELECTRONIC_PRESCRIPTION_UPDATE = "/:id";

// **RUTAS DE FIRMA Y EMISIÓN**
export const API_ELECTRONIC_PRESCRIPTION_SIGN = "/:id/sign";
export const API_ELECTRONIC_PRESCRIPTION_EMIT = "/:id/emit";
export const API_ELECTRONIC_PRESCRIPTION_CANCEL = "/:id/cancel";

// **RUTAS DE CONSULTA**
export const API_ELECTRONIC_PRESCRIPTION_BY_DOCTOR = "/doctor/:id";
export const API_ELECTRONIC_PRESCRIPTION_BY_PATIENT = "/patient/:id";
export const API_ELECTRONIC_PRESCRIPTION_SEARCH = "/search"; // Faltaba esta

// **RUTAS PARA FARMACIA**
export const API_ELECTRONIC_PRESCRIPTION_DISPENSATION = "/:id/dispensation";

// **RUTAS DE UTILIDAD**
export const API_ELECTRONIC_PRESCRIPTION_EXPIRING = "/expiring";
export const API_ELECTRONIC_PRESCRIPTION_HISTORY = "/:id/history";
export const API_ELECTRONIC_PRESCRIPTION_STATS_DOCTOR = "/stats/doctor/:id"; // Faltaba esta

// ========================================================================
// 💰 GESTIÓN DE FACTURACIÓN - ACTIVIDADES FACTURABLES Y ÓRDENES DE VENTA
// ========================================================================

// Base URL para el módulo de facturación
export const API_BASE_BILLING_URL = `${API_BASE_URL}/billing`;

// ========================================================================
// 🆕 RUTAS PARA GESTIÓN COMPLETA DE FACTURACIÓN POR PACIENTE
// ========================================================================

export const API_PATIENTS_BILLING_LIST = "/patients-billing"; // GET - Obtener todos los pacientes con sus actividades facturables
export const API_PATIENTS_BILLING_CREATE_INVOICE_FROM_ACTIVITIES = "/patients-billing/create-invoice-from-activities"; // 🎯 POST - Crear factura desde actividades originales (FLUJO UNIFICADO)
export const API_PATIENTS_BILLING_CREATE_INVOICE = "/patients-billing/create-invoice"; // POST - Crear facturas desde actividades seleccionadas (flujo legacy)
export const API_PATIENTS_BILLING_INVOICES_LIST = "/patients-billing/invoices"; // GET - Obtener facturas existentes con sus líneas
export const API_PATIENTS_BILLING_INVOICE_DETAILS = "/patients-billing/invoices"; // GET - Obtener detalle completo de una factura específica (+ /:id)
export const API_PATIENTS_BILLING_INVOICE_CANCEL = "/patients-billing/invoices"; // POST - Cancelar factura y restaurar estados de actividades (+ /:id/cancel)
export const API_PATIENTS_BILLING_VALIDATE_INVOICE = "/patients-billing/validate-invoice"; // POST - Validar actividades antes de crear factura
export const API_PATIENTS_BILLING_PATIENT_ACTIVITIES = `${API_BASE_BILLING_URL}/patients-billing/patient`; // GET - Obtener actividades de un paciente específico (+ /:patientId/activities)

// ========================================================================
// 🧾 BILLABLE ACTIVITIES (ACTIVIDADES FACTURABLES)
// ========================================================================

export const API_BILLABLE_ACTIVITIES_LIST = "/billable-activities"; // GET - Listado y búsqueda de actividades facturables
export const API_BILLABLE_ACTIVITIES_DETAILS = "/billable-activities"; // GET - Detalle de actividad facturable específica (+ /:id)
export const API_BILLABLE_ACTIVITIES_CREATE = "/billable-activities"; // POST - Crear nueva actividad facturable
export const API_BILLABLE_ACTIVITIES_MASSIVE = '/billable-activities/massive'; // POST - Creación masiva de actividades facturables
export const API_BILLABLE_ACTIVITIES_UPDATE = "/billable-activities"; // PUT - Actualizar actividad facturable (+ /:id)
export const API_BILLABLE_ACTIVITIES_SUMMARY = "/billable-activities/summary"; // GET - Resumen y estadísticas de actividades
export const API_BILLABLE_ACTIVITIES_EXPORT = "/billable-activities/export"; // GET - Exportar actividades a Excel/CSV
export const API_BILLABLE_ACTIVITIES_REPRICE = "/billable-activities/reprice"; // POST - Recalcular precios (repricing masivo)
export const API_BILLABLE_ACTIVITIES_NON_BILLABLE = "/billable-activities"; // POST - Marcar como no facturable (+ /:id/non-billable)
export const API_BILLABLE_ACTIVITIES_VALIDATE_SPLIT = "/billable-activities/validate-split"; // POST - Validar configuración de split
export const API_BILLABLE_ACTIVITIES_DELETE = "/billable-activities"; // DELETE - Eliminar actividad facturable (+ /:id, soft delete)
export const API_BILLABLE_ACTIVITIES_RESTORE = "/billable-activities"; // POST - Restaurar actividad eliminada (+ /:id/restore)

// ========================================================================
// 📋 SALES ORDERS (ÓRDENES DE VENTA)
// ========================================================================

export const API_SALES_ORDERS_LIST = "/sales-orders"; // GET - Listado de órdenes de venta
export const API_SALES_ORDERS_DETAILS = "/sales-orders"; // GET - Detalle de orden de venta con líneas (+ /:id)
export const API_SALES_ORDERS_GENERATE = "/sales-orders/generate"; // POST - Generar órdenes de venta (wizard)
export const API_SALES_ORDERS_CANCEL = "/sales-orders"; // POST - Cancelar orden de venta (+ /:id/cancel)

// ========================================================================
// 🔗 INTEGRACIÓN CON ODOO
// ========================================================================

export const API_ODOO_EXPORT_ORDERS = "/integrations/odoo/export-sales-orders"; // POST - Exportar órdenes de venta a Odoo
export const API_ODOO_WEBHOOK_STATUS = "/integrations/odoo/webhooks/order-status"; // POST - Webhook desde Odoo (actualización de estados)
export const API_ODOO_SYNC_STATUS = "/integrations/odoo/sync-status"; // GET - Estado de sincronización con Odoo

// ========================================================================
// 📚 CATÁLOGOS Y AUXILIARES
// ========================================================================

export const API_CATALOGS_NON_BILLABLE_REASONS = "/catalogs/non-billable-reasons"; // GET - Motivos de "No facturable"
export const API_CATALOGS_TAX_PROFILES = "/catalogs/tax-profiles"; // GET - Perfiles de impuesto
export const API_CATALOGS_ACTIVITY_TYPES = "/catalogs/activity-types"; // GET - Tipos de actividades disponibles
export const API_CATALOGS_ACTIVITY_STATUSES = "/catalogs/activity-statuses"; // GET - Estados disponibles para actividades
export const API_CATALOGS_INVOICE_GROUPING_MODES = "/catalogs/invoice-grouping-modes"; // GET - Modos de agrupación de facturas

// ========================================================================
// 🛠️ RUTAS DE UTILIDADES Y HERRAMIENTAS
// ========================================================================

export const API_BILLING_CONFIG = "/config"; // GET - Obtener configuración del módulo de facturación
export const API_BILLING_PING = "/ping"; // GET - Ping de estado del módulo
export const API_BILLING_STATS = "/stats"; // GET - Estadísticas generales del sistema
// ========================================================================
// 🏥 GESTIÓN DE ACTIVIDADES DE PACIENTES - MANTENIDAS
// ========================================================================

// Base URL para patient activities (sin duplicar /patient-activities)
export const API_BASE_PATIENT_ACTIVITIES_URL = `${API_BASE_URL}/patient-activities`;

// Endpoints específicos (solo las rutas adicionales)
export const API_PATIENT_ACTIVITIES_ALL_PATIENTS = "/all-patients";        // GET /all-patients
export const API_PATIENT_ACTIVITIES_SINGLE_PATIENT = "";                   // GET /:patientId  
export const API_PATIENT_ACTIVITIES_CREATE_BILLABLE = "/create-billable";  // POST /:patientId/create-billable


// ========================================================================
// 💊 GESTIÓN DE MEDICINAS - CON RUTAS DEFINIDAS ✅
// ========================================================================

export const API_BASE_MYMEDICINE_URL = `${API_BASE_URL}`;
export const API_MYMEDICINE_LIST = "/mymedicines";
export const API_MYMEDICINE_DETAILS = "/mymedicines";
export const API_MYMEDICINE_CREATE = "/mymedicines";
export const API_MYMEDICINE_UPDATE = "/mymedicines";
export const API_MYMEDICINE_DELETE = "/mymedicines";
export const API_MYMEDICINE_HARD_DELETE = "/mymedicines"; // Para hard delete agregar /hard al final
export const API_MYMEDICINE_BY_USER = "/mymedicines/user";
export const API_MYMEDICINE_BY_PATIENT = "/mymedicines/patient";
export const API_MYMEDICINE_BY_DOCTOR = "/mymedicines/doctor";
export const API_MYMEDICINE_ACTIVE = "/mymedicines/active";
export const API_MYMEDICINE_EXPIRED = "/mymedicines/expired";
export const API_MYMEDICINE_UPCOMING = "/mymedicines/upcoming";
export const API_MYMEDICINE_BULK_ACTION = "/mymedicines/bulk-action";
export const API_MYMEDICINE_EXPORT = "/mymedicines/export";
export const API_MYMEDICINE_STATISTICS = "/mymedicines/statistics";
export const API_MYMEDICINE_CALENDAR = "/mymedicines/calendar";
export const API_MYMEDICINE_SCHEDULE = "/mymedicines/schedule";
export const API_MYMEDICINE_REMINDERS = "/mymedicines/reminders";

// ========================================================================
// 🏥 GESTIÓN DE CONDICIONES MÉDICAS - CON RUTAS DEFINIDAS ✅
// ========================================================================

export const API_BASE_MEDICAL_CONDITION_URL = `${API_BASE_URL}`;
export const API_MEDICAL_CONDITION_LIST = "/medical-conditions";
export const API_MEDICAL_CONDITION_DETAILS = "/medical-conditions";
export const API_MEDICAL_CONDITION_CREATE = "/medical-conditions";
export const API_MEDICAL_CONDITION_UPDATE = "/medical-conditions";
export const API_MEDICAL_CONDITION_DELETE = "/medical-conditions";
export const API_MEDICAL_CONDITION_HARD_DELETE = "/medical-conditions"; // Para hard delete agregar /permanent al final
export const API_MEDICAL_CONDITION_RESTORE = "/medical-conditions"; // Agregar /restore al final
export const API_MEDICAL_CONDITION_BY_PATIENT = "/medical-conditions/patient";
export const API_MEDICAL_CONDITION_BY_ECOSYSTEM = "/medical-conditions/ecosystem";
export const API_MEDICAL_CONDITION_ACTIVE = "/medical-conditions"; // Con query param status=1
export const API_MEDICAL_CONDITION_ONGOING = "/medical-conditions"; // Con query param currentstatus=ongoing
export const API_MEDICAL_CONDITION_RESOLVED = "/medical-conditions"; // Con query param currentstatus=resolved
export const API_MEDICAL_CONDITION_OBSERVATION = "/medical-conditions"; // Con query param currentstatus=observation
export const API_MEDICAL_CONDITION_STATISTICS = "/medical-conditions/stats/overview";
export const API_MEDICAL_CONDITION_BULK_ACTION = "/medical-conditions/bulk-action";
export const API_MEDICAL_CONDITION_EXPORT = "/medical-conditions/export";
export const API_MEDICAL_CONDITION_HISTORY = "/medical-conditions/history";
export const API_MEDICAL_CONDITION_TIMELINE = "/medical-conditions/timeline";
export const API_MEDICAL_CONDITION_REPORTS = "/medical-conditions/reports";

// ======================================================================== 
// 🧪 GESTIÓN DE PRUEBAS MÉDICAS - CON RUTAS DEFINIDAS ✅ 
// ========================================================================

export const API_BASE_MEDICAL_TEST_URL = `${API_BASE_URL}`;

// CRUD Básico
export const API_MEDICAL_TEST_LIST = "/medical-tests";
export const API_MEDICAL_TEST_DETAILS = "/medical-tests";
export const API_MEDICAL_TEST_CREATE = "/medical-tests";
export const API_MEDICAL_TEST_UPDATE = "/medical-tests";
export const API_MEDICAL_TEST_DELETE = "/medical-tests";
export const API_MEDICAL_TEST_HARD_DELETE = "/medical-tests"; // Para hard delete agregar /hard al final

// Por Usuario/Paciente/Doctor
export const API_MEDICAL_TEST_BY_USER = "/medical-tests/user";
export const API_MEDICAL_TEST_BY_PATIENT = "/medical-tests/patient";
export const API_MEDICAL_TEST_BY_DOCTOR = "/medical-tests/doctor";
export const API_MEDICAL_TEST_BY_ECOSYSTEM = "/medical-tests/ecosystem";

// Por Estado/Filtros
export const API_MEDICAL_TEST_PENDING = "/medical-tests/pending";
export const API_MEDICAL_TEST_COMPLETED = "/medical-tests/completed";
export const API_MEDICAL_TEST_OVERDUE = "/medical-tests/overdue";
export const API_MEDICAL_TEST_RECENT = "/medical-tests/recent";

// Por Categoría/Severidad
export const API_MEDICAL_TEST_BY_CATEGORY = "/medical-tests/category";
export const API_MEDICAL_TEST_BY_SEVERITY = "/medical-tests/severity";
export const API_MEDICAL_TEST_NORMAL = "/medical-tests/normal";
export const API_MEDICAL_TEST_ABNORMAL = "/medical-tests/abnormal";
export const API_MEDICAL_TEST_CRITICAL = "/medical-tests/critical";

// Por Fechas
export const API_MEDICAL_TEST_BY_DATE_RANGE = "/medical-tests/date-range";
export const API_MEDICAL_TEST_TODAY = "/medical-tests/today";
export const API_MEDICAL_TEST_THIS_WEEK = "/medical-tests/this-week";
export const API_MEDICAL_TEST_THIS_MONTH = "/medical-tests/this-month";

// Por Proveedor/Facilidad
export const API_MEDICAL_TEST_BY_PROVIDER = "/medical-tests/provider";
export const API_MEDICAL_TEST_BY_FACILITY = "/medical-tests/facility";

// Acciones en Lote
export const API_MEDICAL_TEST_BULK_ACTION = "/medical-tests/bulk-action";
export const API_MEDICAL_TEST_BULK_UPDATE = "/medical-tests/bulk-update";
export const API_MEDICAL_TEST_BULK_DELETE = "/medical-tests/bulk-delete";

// Exportar/Importar
export const API_MEDICAL_TEST_EXPORT = "/medical-tests/export";
export const API_MEDICAL_TEST_IMPORT = "/medical-tests/import";
export const API_MEDICAL_TEST_EXPORT_PDF = "/medical-tests/export-pdf";
export const API_MEDICAL_TEST_EXPORT_EXCEL = "/medical-tests/export-excel";

// Estadísticas y Reportes
export const API_MEDICAL_TEST_STATISTICS = "/medical-tests/statistics";
export const API_MEDICAL_TEST_ANALYTICS = "/medical-tests/analytics";
export const API_MEDICAL_TEST_TRENDS = "/medical-tests/trends";
export const API_MEDICAL_TEST_SUMMARY = "/medical-tests/summary";

// Calendario y Programación
export const API_MEDICAL_TEST_CALENDAR = "/medical-tests/calendar";
export const API_MEDICAL_TEST_SCHEDULE = "/medical-tests/schedule";
export const API_MEDICAL_TEST_UPCOMING = "/medical-tests/upcoming";

// Recordatorios y Notificaciones
export const API_MEDICAL_TEST_REMINDERS = "/medical-tests/reminders";
export const API_MEDICAL_TEST_NOTIFICATIONS = "/medical-tests/notifications";
export const API_MEDICAL_TEST_ALERTS = "/medical-tests/alerts";

// Búsqueda y Filtros Avanzados
export const API_MEDICAL_TEST_SEARCH = "/medical-tests/search";
export const API_MEDICAL_TEST_FILTER = "/medical-tests/filter";
export const API_MEDICAL_TEST_ADVANCED_SEARCH = "/medical-tests/advanced-search";

// Historial y Auditoría
export const API_MEDICAL_TEST_HISTORY = "/medical-tests/history";
export const API_MEDICAL_TEST_AUDIT = "/medical-tests/audit";
export const API_MEDICAL_TEST_VERSIONS = "/medical-tests/versions";

// Comparaciones y Análisis
export const API_MEDICAL_TEST_COMPARE = "/medical-tests/compare";
export const API_MEDICAL_TEST_TRACK_CHANGES = "/medical-tests/track-changes";
export const API_MEDICAL_TEST_PROGRESS = "/medical-tests/progress";

// Templates y Configuración
export const API_MEDICAL_TEST_TEMPLATES = "/medical-tests/templates";
export const API_MEDICAL_TEST_CATEGORIES = "/medical-tests/categories";
export const API_MEDICAL_TEST_REFERENCE_RANGES = "/medical-tests/reference-ranges";

// Integración con otros módulos
export const API_MEDICAL_TEST_LINK_APPOINTMENT = "/medical-tests/link-appointment";
export const API_MEDICAL_TEST_LINK_PRESCRIPTION = "/medical-tests/link-prescription";
export const API_MEDICAL_TEST_RELATED_TESTS = "/medical-tests/related-tests";

// ========================================================================
// 🔐 GESTIÓN DE CONSENTIMIENTOS - CON RUTAS DEFINIDAS ✅
// ========================================================================

export const API_BASE_CONSENT_URL = `${API_BASE_URL}/consent`;

// ======== RUTAS PRINCIPALES CRUD ========
export const API_CONSENT_CREATE = `${API_BASE_URL}/consent/create`;
export const API_CONSENT_BY_PATIENT = `${API_BASE_URL}/consent/patient`;
export const API_CONSENT_DETAILS = `${API_BASE_URL}/consent`;
export const API_CONSENT_REVOKE = `${API_BASE_URL}/consent`;
export const API_CONSENT_BY_GRANTED_TO = `${API_BASE_URL}/consent/granted-to`;
export const API_CONSENT_AVAILABLE_ACTIVITIES = `${API_BASE_URL}/consent/available-activities`;
export const API_CONSENT_CHECK_PERMISSION = `${API_BASE_URL}/consent/check-permission`;

// ========================================================================
// 📦 PRODUCTS (PRODUCTOS)
// ========================================================================

export const API_PRODUCTS_LIST = "/products"; // GET - Listado y búsqueda de productos (filtros: type, serviceType, category, isActive, search)
export const API_PRODUCTS_DETAILS = "/products"; // GET - Detalle de producto específico (+ /:id)
export const API_PRODUCTS_CREATE = "/products"; // POST - Crear nuevo producto
export const API_PRODUCTS_UPDATE = "/products"; // PUT - Actualizar producto (+ /:id)
export const API_PRODUCTS_DELETE = "/products"; // DELETE - Eliminar producto (+ /:id, soft delete)
export const API_PRODUCTS_EXPORT_XML = "/products/export/xml"; // GET - Exportar productos a XML (filtros: type, category, isActive)
export const API_PRODUCTS_IMPORT_XML = "/products/import/xml"; // POST - Importar productos desde XML (multipart/form-data)

// ========================================================================
// 💰 CUSTOMER PRICELISTS (TARIFAS DE CLIENTES)
// ========================================================================

export const API_PRICELISTS_CUSTOMER_LIST = "/pricelists/customer"; // GET - Listado de tarifas de clientes (filtros: productid, userid, companyid, active)
export const API_PRICELISTS_CUSTOMER_DETAILS = "/pricelists/customer"; // GET - Detalle de tarifa específica (+ /:id)
export const API_PRICELISTS_CUSTOMER_CREATE = "/pricelists/customer"; // POST - Crear nueva tarifa de cliente
export const API_PRICELISTS_CUSTOMER_UPDATE = "/pricelists/customer"; // PUT - Actualizar tarifa de cliente (+ /:id)
export const API_PRICELISTS_CUSTOMER_DELETE = "/pricelists/customer"; // DELETE - Eliminar tarifa de cliente (+ /:id)
export const API_PRICELISTS_CUSTOMER_APPLICABLE = "/pricelists/customer/applicable"; // GET - Obtener precio aplicable (query: productid, userid, companyid, quantity)
export const API_PRICELISTS_CUSTOMER_EXPORT_XML = "/pricelists/customer/export/xml"; // GET - Exportar tarifas a XML (filtros: productid, userid, companyid, active)
export const API_PRICELISTS_CUSTOMER_IMPORT_XML = "/pricelists/customer/import/xml"; // POST - Importar tarifas desde XML (multipart/form-data)

// ========================================================================
// 🏭 SUPPLIER PRICELISTS (TARIFAS DE PROVEEDORES)
// ========================================================================

export const API_PRICELISTS_SUPPLIER_LIST = "/pricelists/supplier"; // GET - Listado de tarifas de proveedores (filtros: productid, supplierid, userid, active)
export const API_PRICELISTS_SUPPLIER_DETAILS = "/pricelists/supplier"; // GET - Detalle de tarifa específica (+ /:id)
export const API_PRICELISTS_SUPPLIER_CREATE = "/pricelists/supplier"; // POST - Crear nueva tarifa de proveedor
export const API_PRICELISTS_SUPPLIER_UPDATE = "/pricelists/supplier"; // PUT - Actualizar tarifa de proveedor (+ /:id)
export const API_PRICELISTS_SUPPLIER_DELETE = "/pricelists/supplier"; // DELETE - Eliminar tarifa de proveedor (+ /:id)
export const API_PRICELISTS_SUPPLIER_APPLICABLE = "/pricelists/supplier/applicable"; // GET - Obtener precio aplicable (query: productid, supplierid, userid, quantity)
export const API_PRICELISTS_SUPPLIER_EXPORT_XML = "/pricelists/supplier/export/xml"; // GET - Exportar tarifas a XML (filtros: productid, supplierid, userid, active)
export const API_PRICELISTS_SUPPLIER_IMPORT_XML = "/pricelists/supplier/import/xml"; // POST - Importar tarifas desde XML (multipart/form-data)